import { render, staticRenderFns } from "./keepCustomerMarket.vue?vue&type=template&id=b81c8882&scoped=true&"
import script from "./keepCustomerMarket.vue?vue&type=script&lang=js&"
export * from "./keepCustomerMarket.vue?vue&type=script&lang=js&"
import style0 from "./keepCustomerMarket.vue?vue&type=style&index=0&id=b81c8882&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b81c8882",
  null
  
)

export default component.exports